/**
 * Reglas del tipo y número de documento del contribuyente (formulario del
 * Padrón). Espejo de backend/services/documentoContribuyente.js: si se cambia
 * una regla acá, hay que cambiarla allá también (los dos tienen sus tests).
 *
 *   DNI, LC, LE : solo dígitos, de 6 a 9.
 *   Pasaporte   : letras y números, sin espacios ni símbolos, de 5 a 20
 *                 caracteres, siempre en MAYÚSCULAS.
 */

export const TIPOS_DOCUMENTO = ['DNI', 'LC', 'LE', 'Pasaporte'];

const MENSAJE_DIGITOS = (nombre) => `${nombre} debe tener solo números, entre 6 y 9 dígitos (sin puntos ni letras).`;

export const REGLAS_DOCUMENTO = {
  DNI: {
    regex: /^\d{6,9}$/,
    soloDigitos: true,
    max: 9,
    mensaje: MENSAJE_DIGITOS('El DNI'),
    placeholder: 'Solo números, 6 a 9 dígitos',
  },
  LC: {
    regex: /^\d{6,9}$/,
    soloDigitos: true,
    max: 9,
    mensaje: MENSAJE_DIGITOS('La libreta cívica (LC)'),
    placeholder: 'Solo números, 6 a 9 dígitos',
  },
  LE: {
    regex: /^\d{6,9}$/,
    soloDigitos: true,
    max: 9,
    mensaje: MENSAJE_DIGITOS('La libreta de enrolamiento (LE)'),
    placeholder: 'Solo números, 6 a 9 dígitos',
  },
  Pasaporte: {
    regex: /^[A-Z0-9]{5,20}$/,
    soloDigitos: false,
    max: 20,
    mensaje: 'El pasaporte debe tener solo letras y números, sin espacios ni símbolos, entre 5 y 20 caracteres.',
    placeholder: 'Letras y números, 5 a 20 caracteres',
  },
};

const reglaDe = (tipo) => REGLAS_DOCUMENTO[tipo] || REGLAS_DOCUMENTO.DNI;

export const placeholderDocumento = (tipo) => reglaDe(tipo).placeholder;

// Lo que se deja escribir o pegar en el campo, según el tipo: descarta lo que
// no corresponde y topa el largo. (Sin maxLength en el <input>: el navegador
// recortaría un texto pegado ANTES de limpiarlo y se perdería algún carácter.)
export function filtrarNumeroDocumento(tipo, texto) {
  const regla = reglaDe(tipo);
  const limpio = regla.soloDigitos
    ? String(texto).replace(/\D/g, '')
    : String(texto).toUpperCase().replace(/[^A-Z0-9]/g, '');
  return limpio.slice(0, regla.max);
}

// Mensaje de error del número para ese tipo, o null si es válido. Un número
// vacío no es error acá (lo pide el "obligatorio" del formulario).
export function errorNumeroDocumento(tipo, numero) {
  if (numero === '' || numero == null) return null;
  const regla = reglaDe(tipo);
  return regla.regex.test(String(numero)) ? null : regla.mensaje;
}
